import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=3357573a&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style0 from "../pc.css?vue&type=style&index=0&id=3357573a&scoped=true&lang=css&"
import style1 from "../phone.css?vue&type=style&index=1&id=3357573a&scoped=true&lang=css&"
import style2 from "./banner.vue?vue&type=style&index=2&id=3357573a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3357573a",
  null
  
)

export default component.exports